import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const carbonBlack = defineConnector({
  identifier: "carbonBlack",
  name: "Carbon Black",
  tagLine: "Endpoint detection and response",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ hostname }) =>
    hostname
      ? `https://${hostname.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.conferdeploy\\.net/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "X-Auth-Token",
        value: `${app.secret.apiSecretKey}/${app.secret.apiId}`,
      },
    ]),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In the Carbon Black Cloud console, go to **Settings → API Access** and create a new API key. Note both the API ID and API secret key.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "CBC hostname",
          required: true,
          placeholder: "defense.conferdeploy.net",
          target: { kind: "configuration", field: "hostname" },
          helperText: "Your Carbon Black Cloud console hostname.",
        },
        {
          kind: "input",
          label: "Org key",
          required: true,
          target: { kind: "configuration", field: "orgKey" },
          helperText:
            "Found under **Settings → API Access** or **Settings → General**.",
        },
        {
          kind: "input",
          label: "API ID",
          required: true,
          target: { kind: "secrets", field: "apiId" },
        },
        {
          kind: "input",
          label: "API secret key",
          required: true,
          target: { kind: "secrets", field: "apiSecretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ hostname, orgKey }) =>
      `https://${hostname}/appservices/v6/orgs/${orgKey}/devices/_search`,
  },
});
